import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { Auth } from "aws-amplify"
import Routes from "./Routes"
import './App.css'
import TopMenu from "./components/layout/TopMenu"
import Footer from "./components/layout/Footer"

import { library } from '@fortawesome/fontawesome-svg-core'
import { faFileInvoiceDollar, faBarcode } from '@fortawesome/free-solid-svg-icons'

library.add(faFileInvoiceDollar, faBarcode)

class App extends Component {

  state = {
    isAuthenticated: false,
    isAuthenticating: true,
    authenticatedUser: null
  }

  async componentDidMount() {
    try {
      const auth = await Auth.currentSession()
      this.setAuthenticatedUser(auth.idToken.payload.email)
    }
    catch (e) {
      if (e !== 'No current user') {
        alert(e)
      }
    }
    this.setState({ isAuthenticating: false })
  }

  setAuthenticatedUser = username => {
    this.setState({ authenticatedUser: username })
  }

  handleLogout = async event => {
    await Auth.signOut()
    this.setAuthenticatedUser(null)
    this.props.history.push("/login")
  }

  render() {
    const childProps = {
      isAuthenticated: this.state.authenticatedUser !== null,
      setAuthenticatedUser: this.setAuthenticatedUser,
      authenticatedUser: this.state.authenticatedUser
    }

    return (
      !this.state.isAuthenticating &&
      <div className="App container">
        <TopMenu authenticatedUser={this.state.authenticatedUser} handleLogout={this.handleLogout} />
        <Routes childProps={childProps} />
        <Footer />
      </div>
    )
  }
}

export default withRouter(App)
